var map = {
	"./ai_bubble_button-close.png": 484,
	"./ai_bubble_button.png": 485,
	"./ai_search.svg": 486,
	"./arrow_drop_down.svg": 487,
	"./arrow_left.svg": 488,
	"./arrow_right.svg": 489,
	"./article_image.jpg": 490,
	"./article_image_no_image.svg": 491,
	"./author_image.jpg": 492,
	"./award_01.png": 493,
	"./award_02.png": 494,
	"./back_arrow.svg": 495,
	"./banner_image_decor.svg": 496,
	"./bg_stay_on_top.svg": 497,
	"./block_decor_contact_info.svg": 498,
	"./category_blue.svg": 499,
	"./category_cancer_diseases.svg": 500,
	"./category_early_diagnosis.svg": 501,
	"./category_nearest_branch.svg": 502,
	"./category_patient_rights.svg": 503,
	"./category_prevention_risk_factors.svg": 504,
	"./category_rehabilitation_support.svg": 505,
	"./category_рotel_sick.svg": 506,
	"./category_сonsultation_experts.svg": 507,
	"./chevron_black_left.svg": 508,
	"./chevron_blue_down.svg": 509,
	"./chevron_blue_left.svg": 510,
	"./chevron_blue_up.svg": 511,
	"./clock_outside_icon.svg": 512,
	"./close_icon.svg": 513,
	"./decor_contacts.svg": 514,
	"./decor_cr_sub_category.svg": 515,
	"./decor_event_01.svg": 516,
	"./decor_event_02.svg": 517,
	"./decor_event_article.svg": 518,
	"./decor_forum.svg": 519,
	"./decor_top_branch_activities.svg": 520,
	"./default-avatar.webp": 521,
	"./ellipse.png": 522,
	"./error_page_decor.svg": 523,
	"./file_icon.svg": 524,
	"./hero_image.jpg": 525,
	"./hero_image_branches_mobile.jpg": 526,
	"./hero_image_branches_v2.jpg": 527,
	"./hero_image_category.jpg": 528,
	"./hero_image_clinical_researches.jpg": 529,
	"./hero_image_decor.svg": 530,
	"./hero_image_drugs.jpg": 531,
	"./hero_image_events.jpg": 532,
	"./hero_image_events_mobile.jpg": 533,
	"./hero_image_forum.jpg": 534,
	"./hero_image_newsflashes.jpg": 535,
	"./hero_image_newsflashes_mobile.jpg": 536,
	"./hero_image_rights_services.jpg": 537,
	"./hero_image_speaker_messages.jpg": 538,
	"./hero_image_speaker_messages_mobile.jpg": 539,
	"./hero_image_strong_together.jpg": 540,
	"./hero_image_strong_together_mobile.jpg": 541,
	"./icon_Breast_Cancer_Community.svg": 542,
	"./icon_breast_cancer_forum.svg": 543,
	"./icon_cart.svg": 544,
	"./icon_contact_01.svg": 545,
	"./icon_contact_02.svg": 546,
	"./icon_contact_03.svg": 547,
	"./icon_contact_04.svg": 548,
	"./icon_contact_05.svg": 549,
	"./icon_contact_06.svg": 550,
	"./icon_contact_07.svg": 551,
	"./icon_contact_08.svg": 552,
	"./icon_contact_09.svg": 553,
	"./icon_contact_10.svg": 554,
	"./icon_contact_11.svg": 555,
	"./icon_contact_12.svg": 556,
	"./icon_copy.svg": 557,
	"./icon_delete_comment.svg": 558,
	"./icon_editing_comment.svg": 559,
	"./icon_event_schedule.svg": 560,
	"./icon_hand_heal.svg": 561,
	"./icon_info_lamp.svg": 562,
	"./icon_link_blue.svg": 563,
	"./icon_link_green.svg": 564,
	"./icon_link_pink.svg": 565,
	"./icon_link_yellow.svg": 566,
	"./icon_location.svg": 567,
	"./icon_m_contact.svg": 568,
	"./icon_m_lang.svg": 569,
	"./icon_menu_about_association.svg": 570,
	"./icon_menu_cancer_diseases.svg": 571,
	"./icon_menu_early_diagnosis.svg": 572,
	"./icon_menu_information_professionals.svg": 573,
	"./icon_menu_information_support.svg": 574,
	"./icon_menu_prevention_risk_factors.svg": 575,
	"./icon_notice.svg": 576,
	"./icon_pdf.svg": 577,
	"./icon_prevention_diagnosis.svg": 578,
	"./icon_professional_information.svg": 579,
	"./icon_rehabilitation.svg": 580,
	"./icon_report_response.svg": 581,
	"./icon_research.svg": 582,
	"./icon_search.svg": 583,
	"./icon_share_facebook.svg": 584,
	"./icon_share_link.svg": 585,
	"./icon_share_mail.svg": 586,
	"./icon_share_whatsapp.svg": 587,
	"./icon_tel.svg": 588,
	"./icon_volunteering.svg": 589,
	"./icon_volunteers.svg": 590,
	"./img_mini_contact_form.jpg": 591,
	"./location_icon.svg": 592,
	"./logo.svg": 593,
	"./logo_ar.png": 594,
	"./logo_en.png": 595,
	"./logo_he.svg": 596,
	"./logo_purple.svg": 597,
	"./logo_ru.png": 598,
	"./main_g_circle.svg": 599,
	"./manager_icon.svg": 600,
	"./mask_image_slider.svg": 601,
	"./menu_contact.svg": 602,
	"./menu_icon_ltr.svg": 603,
	"./menu_icon_rtl.svg": 604,
	"./menu_language.svg": 605,
	"./menu_volunteering.svg": 606,
	"./no-image.png": 262,
	"./phone_icon.svg": 607,
	"./purple_light.svg": 608,
	"./search_icon_blue.svg": 609,
	"./search_icon_gray.svg": 610,
	"./share_icon.svg": 611,
	"./social_image_facebook.svg": 612,
	"./social_image_instagram.svg": 613,
	"./social_image_tiktok.svg": 614,
	"./social_image_twitter.svg": 615,
	"./social_image_youtube.svg": 616,
	"./step_images_slider.png": 617,
	"./successfully_icon.svg": 618,
	"./tabs_activities_decor.svg": 619,
	"./user.jpg": 620,
	"./user_icon.svg": 621,
	"./video_image.jpg": 622,
	"./volunteers_hero_image.png": 623,
	"./volunteers_hero_image_svg.svg": 624,
	"./way_hero_image_v3.png": 625,
	"./whats_new_icon.svg": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;